export class WardGroupType {
    campusWardGroupTypeId: number;
    name: string;
    allowMales: boolean;
    allowFemales: boolean;
    active: boolean;
}
